<template>
	<div class="booking-widget" ref="widget">
		<form :method="formMethod" :action="$root.appConfig.continueUrl" class="widgetForm">


			<FormRow @click.prevent="scrollToMe">
				<DestinationInput :continents="continents" :allContinentsLabel="$root.appConfig.language.allHotels" :destination="destination" @destinationChange="destinationChange" @open="onOpen" @close="onClose"></DestinationInput>
			</FormRow>

			<FormRow @click.prevent="scrollToMe">
				<InputDate :start="arrival" :end="departure" @dateChange="dateChange" @input="dateChange"/>
			</FormRow>

			<FormRow @click.prevent="scrollToMe">
				<RoomGuestInput :guests="guests" :rooms="rooms" @changeRooms="updateRooms" @changeGuests="updateGuests" @open="onOpen" @close="onClose"></RoomGuestInput>
			</FormRow>

			<input type="hidden" name="destination" :value="destination">
			<input type="hidden" name="promo" :value="$root.appConfig.promo_code">
			<input type="hidden" name="action" value="dates">

			<Button type="submit" fullwidth :disabled="isDirty ? null : 'disabled'" :aria-disabled="isDirty ? null : 'disabled'">
				{{ $root.appConfig.language.buttonLabel }}
			</Button>

		</form>
	</div>
</template>

<script>
import {
	// PaperSurface,
	Button,
	InputDate,
	FormRow,
	// MobileModal,
} from 'citizen-shared-components';

import DestinationInput from './components/DestinationInput'
import RoomGuestInput from './components/RoomGuestInput'

export default {
	name: 'BookingWidget',
	components: {
		// MobileModal,
		FormRow,
		InputDate,
		// PaperSurface,
		Button,
		DestinationInput,
		RoomGuestInput,
	},
	data() {
		return {
			arrival: new Date(this.$root.appConfig.arrival),
			departure: new Date(this.$root.appConfig.departure),
			guests: this.$root.appConfig.guests,
			rooms: this.$root.appConfig.rooms,
			destination: this.$root.appConfig.destination,
			allContinentsLabel: 'All',

			continents: this.$root.appConfig.continents,

			isDirty: this.$root.appConfig.inactiveButtonOnLoad ? false : true,
		}
	},
	computed: {
		formMethod(){
			return 'POST'
		},
	},
	methods: {
		destinationChange(dest){
			this.destination = dest
			this.isDirty = true
		},
		updateRooms(rooms){
			this.rooms = rooms
			this.isDirty = true
		},
		updateGuests(guests){
			this.guests = guests
			this.isDirty = true
		},
		onOpen(){
			try {
				if(window.innerWidth < 768) {
					document.body.classList.add('openNavigation','openHamburger');
					const header = document.querySelector('.header-sixty');
					if(header){
						header.style.zIndex = 'unset'
					}
				}
				else {
					window.scrollBy({
						top: this.$refs.widget.getBoundingClientRect().top - 100,
						behavior: 'smooth'
					})
				}
			} catch (e) { /**/ }
		},
		onClose(){
			try {
				document.body.classList.remove('openNavigation','openHamburger');
				const header = document.querySelector('.header-sixty');
				if(header){
					header.removeAttribute('style')
				}
			} catch (e) { /**/ }
		},
		dateChange(){
			this.isDirty = true
			this.onClose()
		}
	}
}
</script>
<style lang="scss">
@import "@/assets/styles/app.scss";
@import "@/assets/styles/utils/_mixins.scss";

.booking-widget {
	padding: 16px;
	margin-left: 11px;
	margin-right: 11px;
	background: var(--primary-white);
	border-radius: 4px;
	max-width: 1200px;

	input:focus {
		box-shadow: none;
	}
	.button {
		min-width: unset;
		&::after {
			display: none;
		}
	}

	.paper-content > * {
		margin-bottom: 16px;
	}
	button[disabled] {
		box-shadow: none;
		//box-shadow: none !important;
	}
	.widgetForm {
		> .form-row {
			> * {
				flex: 1;
			}
		}
	}
	fieldset {
		flex: 1;
	}
}

@include mdx {
	.hero_property--widget-only {
		padding: 0 !important;
	}
	.hero_property--widget-only .booking-widget {
		box-shadow: var(--shadow);
		width: calc(100% - 22px);
	}
	.position_wrap .booking-widget {
		box-shadow: var(--shadow);
		width: calc(100% - 22px);
		bottom: -77px;
		position: absolute;
	}
}
@include md {

	.booking-widget {
		padding: 0 16px;
		box-shadow: var(--shadow);
		margin-right: auto;
		margin-left: auto;
		width: 100%;

		position: absolute;
		bottom: 70px;
		left: 50%;
		transform: translateX(-50%);
	}

	.widgetForm {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;

		> .form-row {
			flex: 1;
			padding: 24px 8px;
			margin-bottom: 0;
			> * {
				position: relative;
				flex: 1;
			}
		}
		> button, > a {
			flex: 0;
		}
		.input-wrap {
			width: 100%;
		}
		.input-date .input {
			padding-bottom: 0;
		}

		> button,
		> button:last-child {
			margin: 24px 8px;
			width: 122px;
			flex-basis: 122px;
		}
	}

	.modal-container {
		position: absolute;
		margin-top: 8px;
		opacity: 0;
		pointer-events: none;
		width: calc(100% + 11px);
		background: var(--primary-white);

		box-shadow: var(--shadow);

		&.visible{
			opacity: 1;
			pointer-events: all;
		}
		.modal-body {
			max-height: 500px;
			overflow: hidden;
			overflow-y: auto;
		}
	}

	div.hero_property {
		margin: auto;
		z-index: 12;
		.booking-widget {
			position: static;
			transform: none;
			margin: 0 auto 60px;
		}
	}
}
.vc-popover-content-wrapper {
	padding-top: 60px;
	z-index: 9998 !important;
}
</style>